export const SET_LOG_IN = 'SET_LOG_IN';

export const SET_LOG_OUT = 'SET_LOG_OUT';

export const setLogIn = () => {
    return {
        type : SET_LOG_IN,
    };
};

export const setLogOut = () => {
    return {
        type : SET_LOG_OUT,
    };
};
